
import Vue, {VueConstructor} from 'vue'
import {SelectOption} from '~/components/ui/select.vue'
import FilterStateMixin from '~/mixins/filter-state.mixin'
import {EVENT_SEARCH} from '~/util/event-bus'
import ResponsiveMixin from '~/mixins/responsive.mixin'
import {mapGetters} from 'vuex'
import {find, isArray} from 'lodash'
import {SortingKey} from '~/store/filter'
import ContactCard from '~/components/ui/contact-card.vue'

export interface FilterFeature {
  id: number;
  name: string;
  slug: string;
  description: string | null;
  listing_count: number;
  image: string | null;
}

export interface FilterCategory {
  id: number;
  name: string;
  slug: string;
  description: string | null;
  features: FilterFeature[]
}

export interface FilterResponse {
  categories: { [key: string]: FilterCategory }[];
}

export default (Vue as VueConstructor<Vue & InstanceType<typeof FilterStateMixin> & InstanceType<typeof ResponsiveMixin>>).extend({
  name: 'FilterColumn',
  components: {ContactCard},
  mixins: [FilterStateMixin, ResponsiveMixin],
  data(): {
    loading: boolean,
    showSuperChefPopup: boolean,
    mobileFilterScreenOpen: boolean,
    sortOptions: SelectOption[]
  } {
    return {
      loading: false,
      showSuperChefPopup: false,
      mobileFilterScreenOpen: false,
      sortOptions: [
        {
          key: SortingKey.RECOMMENDED,
          value: 'Aanbevolen'
        },
        {
          key: SortingKey.PRICE,
          value: 'Prijs'
        },
        {
          key: SortingKey.DISTANCE,
          value: 'Afstand'
        },
        {
          key: SortingKey.CHEF_SCORE,
          value: 'Best beoordeeld'
        },
        {
          key: SortingKey.REVIEW_AMOUNT,
          value: 'Meeste reviews'
        },
        {
          key: SortingKey.NEWEST,
          value: 'Nieuwste'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      pagination: 'filter/pagination',
      sortingKey: 'filter/sortingKey',
      filterData: 'filter/filterData',
    }),
    minValue(): number {
      // todo should be null when not present and thus not pushed to backend
      return (this.pagination?.price_min ?? 100) / 100;
    },
    maxValue(): number {
      // todo ^
      return (this.pagination?.price_max ?? 99900) / 100;
    },
    min: {
      get(): number {
        // @ts-ignore
        return this.getDynamicValue('price_min') !== undefined ? this.getDynamicValue('price_min') / 100 : this.minValue;
      },
      set(value: number) {
        // @ts-ignore
        this.updateDynamicValue('price_min', (value * 100));
      }
    },
    max: {
      get(): number {
        // @ts-ignore
        return this.getDynamicValue('price_max') !== undefined ? this.getDynamicValue('price_max') / 100 : this.maxValue;
      },
      set(value: number) {
        // @ts-ignore
        this.updateDynamicValue('price_max', (value * 100));
      }
    },
    // Sort
    chefFilter: {
      get(): SelectOption | null {
        return find(this.sortOptions, {
          key: this.sortingKey
        }) ?? null
      },
      set(val: SelectOption | null) {
        this.$store.commit('filter/UPDATE_SORTING_KEY', val?.key ?? null);
        this.$nuxt.$emit(EVENT_SEARCH, {});
      }
    },
    dynamicFilters(): SelectOption[] {
      const filters = this.filters.dynamicFilters ?? {};
      const filterKeys = Object.keys(filters);
      let formattedFilters: SelectOption[] = [];

      filterKeys.forEach(key => {
        const item = filters[key];

        if (isArray(item)) {
          formattedFilters.push(...item);
        }
      })

      return formattedFilters;
    },
    totalChefs(): number {
      return (this.pagination?.total ?? 0)
    },
    filterCategories(): { [key: string]: FilterCategory }[] {
      return this.filterData !== undefined ? this.filterData.categories ?? [] : []
    }
  },
  methods: {
    mapFeatures(features: FilterFeature[]): SelectOption[] {
      return features.map(f => {
        return {
          key: f.id.toString(10),
          value: f.name
        }
      })
    },
    openMobileMenu() {
      this.$emit('mobileMenuOpen', true);
    },
    resetFilters() {
      this.$store.commit('filter/UPDATE_FILTERS', {
        dynamicFilters: {},
      });

      this.$store.commit('filter/UPDATE_SORTING_KEY', SortingKey.CHEF_SCORE);

      this.$nuxt.$emit(EVENT_SEARCH, {});
    }
  },
  async mounted() {
    this.$nuxt.$on('openAddressFilter', () => {
      // @ts-ignore
      this.isAddressOpen = true
    })
  },
  beforeDestroy() {
    this.$nuxt.$off('openAddressFilter')
  },
})
